// extracted by mini-css-extract-plugin
export default {"card":"NotasProfesor_card__Rio1X","placeholder":"NotasProfesor_placeholder__6eSE0","fab":"NotasProfesor_fab__xgrq7"};